'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidder = require('./remote/bidder');

var Bidder = {
    fetchBidderData: _bidder.BidderRemote.fetchBidderData,
    postBidderConsent: _bidder.BidderRemote.postBidderConsent,
    postCompleteAccount: _bidder.BidderRemote.postCompleteAccount,
    postCreateAccount: _bidder.BidderRemote.postCreateAccount,
    postLogin: _bidder.BidderRemote.postLogin,
    postSetPassword: _bidder.BidderRemote.postSetPassword,
    postSetSearchFacetOptionExclusion: _bidder.BidderRemote.postSetSearchFacetOptionExclusion
};

exports.default = Bidder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bidder.js
// module id = Hwmz
// module chunks = 60